export default __webpack_public_path__ + "static/media/twilio.1645ab19.svg";